'use client';

import React, { RefObject } from 'react';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

type ScrollTopFabProps = {
  anchorRef: RefObject<HTMLElement | null>;
};

/** Scrolls the page back to the anchor at the top of the main content. */
export const ScrollTopFab = ({ anchorRef }: ScrollTopFabProps) => {
  const handleClick = () => {
    anchorRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  return (
    <Fab
      color="primary"
      size="small"
      aria-label="scroll back to top"
      onClick={handleClick}
    >
      <KeyboardArrowUpIcon />
    </Fab>
  );
};
